import { ShieldAlert } from "lucide-react";

/** Full-screen black overlay shown when anti-piracy detects an attempt. */
export default function AntiPiracyOverlay({ visible, onDismiss }) {
  if (!visible) return null;
  return (
    <div
      className="fixed inset-0 z-[100] bg-black text-white grid place-items-center px-6"
      data-testid="anti-piracy-overlay"
    >
      <div className="max-w-sm text-center">
        <ShieldAlert className="w-14 h-14 text-[#FF0050] mx-auto" />
        <h2 className="mt-5 text-2xl font-black font-display">Enregistrement non autoris&eacute;</h2>
        <p className="mt-3 text-zinc-400 text-sm leading-relaxed">
          Le contenu Metazik est prot&eacute;g&eacute; contre le piratage. Toute reproduction ou
          enregistrement non autoris&eacute; est strictement interdit et passible de
          poursuites judiciaires.
        </p>
        <button
          onClick={onDismiss}
          className="mt-6 px-6 py-2 rounded-full bg-white text-black font-bold text-sm"
          data-testid="anti-piracy-dismiss"
        >
          J&apos;ai compris
        </button>
      </div>
    </div>
  );
}
